import { log, FACILITY } from './log';
import { LEFT_SIDE, RIGHT_SIDE, SAGITTAL, CORONAL, TRANSVERSE, Axis, } from '../types';
import { parseTuple } from '../analytics-lib/analytics-tuple';
var LOG = FACILITY.GENERAL;
function getRow(values) {
    return (values.reduce(function (acc, el, index) {
        if (index > 0) {
            acc += ', ';
        }
        return acc + el;
    }, '') + '\n');
}
function getColumnHeaders(version) {
    if (version === '3.1') {
        return [
            'timestamp (ms)',
            'GRF_mag_L',
            'GRF_mag_R',
            'GRF_dir_L_X',
            'GRF_dir_L_Y',
            'GRF_dir_L_Z',
            'GRF_dir_R_X',
            'GRF_dir_R_Y',
            'GRF_dir_R_Z',
            'knee_moment_L_X',
            'knee_moment_L_Y',
            'knee_moment_L_Z',
            'knee_moment_R_X',
            'knee_moment_R_Y',
            'knee_moment_R_Z',
            'knee_load_L',
            'knee_load_R',
            'knee_L_flexion',
            'knee_R_flexion',
            'sacral_moment_X',
            'sacral_moment_Y',
            'sacral_moment_Z',
            'sacral_load',
            'hip_L_flexion',
            'hip_R_flexion',
            'COM_UpperBody_X',
            'COM_UpperBody_Y',
            'COM_UpperBody_Z',
            'COM_X',
            'COM_Y',
            'COM_Z',
        ];
    }
    return [
        'timestamp (ms)',
        'GRF_mag_L',
        'GRF_mag_R',
        'GRF_dir_L_X',
        'GRF_dir_L_Y',
        'GRF_dir_L_Z',
        'GRF_dir_R_X',
        'GRF_dir_R_Y',
        'GRF_dir_R_Z',
        'knee_moment_L_X',
        'knee_moment_L_Y',
        'knee_moment_L_Z',
        'knee_moment_R_X',
        'knee_moment_R_Y',
        'knee_moment_R_Z',
        'knee_load_L',
        'knee_load_R',
        'knee_L_sagittal',
        'knee_L_coronal',
        'knee_L_transverse',
        'knee_R_sagittal',
        'knee_R_coronal',
        'knee_R_transverse',
        'sacral_moment_X',
        'sacral_moment_Y',
        'sacral_moment_Z',
        'sacral_load',
        'hip_L_sagittal',
        'hip_L_coronal',
        'hip_L_transverse',
        'hip_R_sagittal',
        'hip_R_coronal',
        'hip_R_transverse',
        'COM_UpperBody_X',
        'COM_UpperBody_Y',
        'COM_UpperBody_Z',
        'COM_X',
        'COM_Y',
        'COM_Z',
    ];
}
function parseFrame(version, frame) {
    if (version === '3.1') {
        return [
            frame['timestamp'],
            frame['groundReactionForce']['magnitude'][LEFT_SIDE],
            frame['groundReactionForce']['magnitude'][RIGHT_SIDE],
            frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.X],
            frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.Y],
            frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.Z],
            frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.X],
            frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.Y],
            frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.Z],
            frame['knee']['moment'][LEFT_SIDE][Axis.X],
            frame['knee']['moment'][LEFT_SIDE][Axis.Y],
            frame['knee']['moment'][LEFT_SIDE][Axis.Z],
            frame['knee']['moment'][RIGHT_SIDE][Axis.X],
            frame['knee']['moment'][RIGHT_SIDE][Axis.Y],
            frame['knee']['moment'][RIGHT_SIDE][Axis.Z],
            frame['knee']['load'][LEFT_SIDE],
            frame['knee']['load'][RIGHT_SIDE],
            frame['knee']['flexion'][LEFT_SIDE],
            frame['knee']['flexion'][RIGHT_SIDE],
            frame['sacral']['moment'][Axis.X],
            frame['sacral']['moment'][Axis.Y],
            frame['sacral']['moment'][Axis.Z],
            frame['hip']['flexion'][LEFT_SIDE],
            frame['hip']['flexion'][RIGHT_SIDE],
            frame['centerOfMassUpperBody']['point'][Axis.X],
            frame['centerOfMassUpperBody']['point'][Axis.Y],
            frame['centerOfMassUpperBody']['point'][Axis.Z],
            frame['centerOfMass']['point'][Axis.X],
            frame['centerOfMass']['point'][Axis.Y],
            frame['centerOfMass']['point'][Axis.Z],
        ];
    }
    return [
        frame['timestamp'],
        frame['groundReactionForce']['magnitude'][LEFT_SIDE],
        frame['groundReactionForce']['magnitude'][RIGHT_SIDE],
        frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.X],
        frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.Y],
        frame['groundReactionForce']['direction'][LEFT_SIDE][Axis.Z],
        frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.X],
        frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.Y],
        frame['groundReactionForce']['direction'][RIGHT_SIDE][Axis.Z],
        frame['knee']['moment'][LEFT_SIDE][Axis.X],
        frame['knee']['moment'][LEFT_SIDE][Axis.Y],
        frame['knee']['moment'][LEFT_SIDE][Axis.Z],
        frame['knee']['moment'][RIGHT_SIDE][Axis.X],
        frame['knee']['moment'][RIGHT_SIDE][Axis.Y],
        frame['knee']['moment'][RIGHT_SIDE][Axis.Z],
        frame['knee']['load'][LEFT_SIDE],
        frame['knee']['load'][RIGHT_SIDE],
        frame['knee']['angles'][LEFT_SIDE][SAGITTAL],
        frame['knee']['angles'][LEFT_SIDE][CORONAL],
        frame['knee']['angles'][LEFT_SIDE][TRANSVERSE],
        frame['knee']['angles'][RIGHT_SIDE][SAGITTAL],
        frame['knee']['angles'][RIGHT_SIDE][CORONAL],
        frame['knee']['angles'][RIGHT_SIDE][TRANSVERSE],
        frame['sacral']['moment'][Axis.X],
        frame['sacral']['moment'][Axis.Y],
        frame['sacral']['moment'][Axis.Z],
        frame['hip']['angles'][LEFT_SIDE][SAGITTAL],
        frame['hip']['angles'][LEFT_SIDE][CORONAL],
        frame['hip']['angles'][LEFT_SIDE][TRANSVERSE],
        frame['hip']['angles'][RIGHT_SIDE][SAGITTAL],
        frame['hip']['angles'][RIGHT_SIDE][CORONAL],
        frame['hip']['angles'][RIGHT_SIDE][TRANSVERSE],
        frame['centerOfMassUpperBody']['point'][Axis.X],
        frame['centerOfMassUpperBody']['point'][Axis.Y],
        frame['centerOfMassUpperBody']['point'][Axis.Z],
        frame['centerOfMass']['point'][Axis.X],
        frame['centerOfMass']['point'][Axis.Y],
        frame['centerOfMass']['point'][Axis.Z],
    ];
}
var columns = [
    'timestamp',
    'ground_force_x_left',
    'ground_force_y_left',
    'ground_force_z_left',
    'ground_force_x_right',
    'ground_force_y_right',
    'ground_force_z_right',
    'hip_moment_sagital_left',
    'hip_moment_coronal_left',
    'hip_moment_transverse_left',
    'hip_moment_sagital_right',
    'hip_moment_coronal_right',
    'hip_moment_transverse_right',
    'hip_angle_sagital_left',
    'hip_angle_coronal_left',
    'hip_angle_transverse_left',
    'hip_angle_sagital_right',
    'hip_angle_coronal_right',
    'hip_angle_transverse_right',
    'knee_angle_sagital_left',
    'knee_angle_coronal_left',
    'knee_angle_transverse_left',
    'knee_angle_sagital_right',
    'knee_angle_coronal_right',
    'knee_angle_transverse_right',
    'knee_moment_sagital_left',
    'knee_moment_coronal_left',
    'knee_moment_transverse_left',
    'knee_moment_sagital_right',
    'knee_moment_coronal_right',
    'knee_moment_transverse_right',
];
function tupleValues(tuple) {
    return columns.map(function (key) {
        if (key === 'timestamp') {
            return tuple.timestamp;
        }
        return parseTuple(key, tuple.tuple);
    });
}
export function datasetToCsv(obj) {
    if (obj.version === '3.3' || obj.version === '3.4') {
        console.log("Dataset version " + obj.version);
        var result_1 = getRow(columns);
        obj.timings.forEach(function (time) {
            (result_1 += getRow(tupleValues(obj.analyticTuples[time])));
        });
        return result_1;
    }
    if (obj.version === '3.1' || obj.version === '3.2') {
        var result_2 = getRow(getColumnHeaders(obj.version));
        obj.timings.forEach(function (time) {
            (result_2 += getRow(parseFrame(obj.version, obj.analytics[time])));
        });
        return result_2;
    }
    log.error(LOG, "datasetToCsv unsupported dataset version " + obj.version);
    return '';
}
//# sourceMappingURL=dataset-csv.js.map